var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ag-grid-vue',{staticClass:"ag-theme-balham",staticStyle:{"height":"100% !important"},attrs:{"column-defs":_vm.cols,"row-data":_vm.rows,"pagination":_vm.pagination,"paginationPageSize":_vm.paginationPageSize},on:{"grid-ready":_vm.onGridReady}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }